















import Component, { mixins } from 'vue-class-component';
import Form from '@/general/abstract/form/mixin/Form';
import FormBase from '@/general/abstract/form/FormBase.vue';
import { VModel } from 'vue-property-decorator';
import FacilityFormTemplate from '@/context/facility/component/FacilityFormTemplate.vue';
import { FacilityFormModel } from '@/context/facility/model/FacilityFormModel';
import { FacilityModel } from '@/context/facility/model/FacilityModel';
import { facilityRouter } from '@/context/facility/router/FacilityRouter';
import { facilityApi } from '@/context/facility/api/FacilityApi';

@Component({
  components: {
    FacilityFormTemplate,
    FormBase
  }
})
export default class FacilityForm extends mixins<
  Form<FacilityFormModel, FacilityFormModel, FacilityModel>
>(Form) {
  @VModel({ default: new FacilityFormModel() }) model!: FacilityFormModel;
  buildCmd(): FacilityFormModel {
    return this.model;
  }

  async submitApi(cmd: FacilityFormModel): Promise<FacilityModel> {
    const model: FacilityModel = cmd.id
      ? facilityApi.update<FacilityModel, FacilityFormModel>(cmd)
      : facilityApi.create<FacilityModel, FacilityFormModel>(cmd);
    return model;
  }

  showRoute(id: number): Record<string, unknown> {
    return facilityRouter.show(id);
  }
}
